<template>
  <div>
    <div
      v-loading="loading"
      :element-loading-text="loadingText"
      element-loading-spinner="el-icon-loading"
    >
      <div>
        <!-- <el-button type="success" size="mini" icon="el-icon-arrow-left" @click="goBack"
        style="background-color:#008A2C;float: left;">返回个人中心
        </el-button>-->
        <div @click="goBack" style="cursor: pointer; color: #008a2c">
          <el-button type="info" style="background-color: #008a2c" icon="el-icon-back" circle></el-button>&nbsp;返回个人中心
        </div>
        <div class="f20 tc fb">{{ detailData.f1 }}-审批</div>
      </div>

      <div style="margin-top: 30px">
        <el-row :gutter="20">
          <el-col :span="5" :offset="4">
            <div>
              <span class="fb">申请事项：</span>
              {{ detailData.f1 }}
            </div>
          </el-col>
          <el-col :span="5">
            <div>
              <span class="fb">申请人：</span>
              {{ detailData.applyUser }}
            </div>
          </el-col>
          <el-col :span="5">
            <div>
              <span class="fb">申请时间：</span>
              {{ moment(detailData.applyTime).format("YYYY-MM-DD HH:mm:ss") }}
            </div>
          </el-col>
        </el-row>
      </div>
      <el-divider></el-divider>
      <div style="border: 1px solid #ececec; margin-bottom: 10px; padding: 10px">
        <el-row>
          <el-col :span="2">
            <div>审批意见：</div>
          </el-col>
          <el-col :span="22">
            <div>
              <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="textarea"></el-input>
              <div style="height: 10px"></div>
              <el-button type="success" size="medium" @click="approve">通过</el-button>
              <el-button type="danger" size="medium" @click="rollback" v-if="active != '0'">驳回</el-button>
              <!-- <el-button type="primary" size="medium" @click="update"
              >转办</el-button
              >-->
              <el-button type="info " size="medium" @click="reject">终止</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <el-row :gutter="20">
        <el-col :span="18">
          <div style="min-height: 600px; border: 1px solid #ececec">
            <iframe
              style="position: relative"
              name="iframeID"
              id="iframeID"
              width="100%"
              height="600px"
              :src="detailUrl"
              frameborder="0"
              scrolling
            ></iframe>
          </div>
        </el-col>
        <el-col :span="6">
          <div style="min-height: 600px; border: 2px solid #ececec">
            <div class="rightbox">审批记录</div>
            <div style="padding: 15px">
              <el-steps direction="vertical" :active="active">
                <el-step
                  title
                  :status="item.result==1?'wait':item.result==2?'success':item.result==3?'error':''"
                  :icon="item.result==1?'el-icon-circle-check':''"
                  v-for="item in matterData1"
                  :key="item.id"
                >
                  <div slot="title" >
                    <p>{{ item.name }}</p>
                  </div>
                  <div slot="description" style="color: black; margin-bottom: 10px">
                    <p>
                      {{
                      moment(item.createTime).format("YYYY-MM-DD HH:mm:ss")
                      }}
                    </p>
                    <p>
                      <span style="font-weight: bold;">{{ item.assigneeUser.nickname }}</span>
                      <span>【{{ item.assigneeUser.deptName }}】</span>
                    </p>
                    <p>审批意见：</p>
                    <p>{{ item.reason }}</p>
                  </div>
                </el-step>
                <el-step icon="el-icon-circle-check" status="wait" title="事项办理结束"></el-step>
                <!-- <el-step title="2022.10.20 17:12:21" process-status="error" icon="el-icon-circle-close">
                <div slot="description" style="color:black;margin-bottom: 10px;">
                  <p>张三 物联网研究院</p>
                  <p>审批意见：</p>
                  <p>xxxxxxx</p>
                </div>
              </el-step>
              <el-step title="步骤 3">
                <div slot="description" style="color:black;margin-bottom: 10px;">
                  <p>张三 物联网研究院</p>
                  <p>审批意见：</p>
                  <p>xxxxxxx</p>
                </div>
                </el-step>-->
              </el-steps>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import { mapGetters } from "vuex";
import {
  queryMatter,
  approveMatter,
  rejectMatter,
  rollbackMatter,
  updateMatter,
  queryRunById
} from "@/api/matter.js";
import { sendMsg } from "@/api/serviceInfo.js";
import { updatehandlestate } from "@/api/accessAuthorization";
import {schoolupdateHandleState} from "@/api/SHMReservat"
import {copyServiceUpdatehandlestate} from "@/api/admissionRosterCopy"
export default {
  name: "matterApproval",
  data() {
    return {
      textarea: "",
      detailUrl: "",
      matterData: [],
      matterData1: [],
      matterid: "",
      runid: "",
      detailid: "",
      detailData: {},
      active: 1,
      loadingText: "数据正在加载中，请稍后...",
      loading: true
    };
  },
  computed: {
    ...mapGetters(["getUserInfo"])
  },
  mounted() {
    this.runid = this.$route.query.runid;
    this.detailid = this.$route.query.detailid;
    this.matterid = this.$route.query.id;
    setTimeout(() => {
      this.loading = false;
    }, 200);
    this.getMatter();
    this.getRunById();
  },
  methods: {
    moment,
    async getMatter() {
      await queryMatter(this.matterid).then(res => {
        if (res.code == 0) {
          let json = "";
          json = JSON.stringify(res.data);
          this.matterData = JSON.parse(json);
          this.active = this.matterData.length - 1;
          this.matterData1 = JSON.parse(json).reverse();
        }
      });
    },
    //通过
    approve() {
      this.loading = true;
      this.loadingText = "正在审批中，请稍后！";
      let params = {
        id: this.matterData[0].id,
        reason: this.textarea
      };
      approveMatter(params)
        .then(res => {
          console.log(res);
          this.loading = false;
          if (res.data == true) {
            this.$message({
              message: "审批通过！",
              type: "success"
            });
            queryMatter(this.matterid).then(async res => {
              if (res.code == 0) {
                if (res.data.length != this.matterData.length) {
                  if (this.detailData.serviceId === "1575693429255712770") {
                    //门禁授权流程
                    let data1 = {
                      id: this.detailData.serviceRunid,
                      handlestate: 2
                    };
                    await updatehandlestate(JSON.stringify(data1));
                  } else if (this.detailData.serviceId === "1575738395629727746") {
                    //校史馆流程
                    let data1 = {
                      id: this.detailData.serviceRunid,
                      handlestate: 2
                    };
                    await schoolupdateHandleState(JSON.stringify(data1));
                  }else if (this.detailData.serviceId === "1706953037240614913") {
                    //查询复印服务
                    let data1 = {
                      id: this.detailData.serviceRunid,
                      handlestate: 2
                    };
                    await copyServiceUpdatehandlestate(JSON.stringify(data1));
                  }
                  let data = {
                    id: this.detailData.serviceRunid + "-1", //事项id
                    receiveUser: res.data[0].assigneeUser.id, //接收者userId
                    memo:
                      "您收到一个【" +
                      this.matterData[0].processInstance.name +
                      "】的待处理事项，请及时处理！", //消息内容
                    sendUser: res.data[1].assigneeUser.id, //发送者userId
                    serviceId: this.detailData.serviceId, //服务id
                    f4: this.matterData[0].processInstance.name
                  };
                  console.log(data);
                  sendMsg(data).then(res => {
                    console.log(res);
                    if (res.msgCode == 0) {
                      this.goBack();
                    }
                  });
                }
              }
            });
            this.goBack();
          } else {
            this.$message({
              message: res.msg,
              type: "error"
            });
          }
        })
        .catch(e => {
          this.loading = false;
          this.$message({
            message: e.msg,
            type: "error"
          });
        });
    },
    //终止
    reject() {
      this.loading = true;
      this.loadingText = "正在终止中，请稍后！";
      let params = {
        id: this.matterData[0].id,
        reason: this.textarea
      };
      rejectMatter(params)
        .then(res => {
          console.log(res);
          this.loading = false;
          if (res.data == true) {
            this.$message({
              message: "审批终止！",
              type: "success"
            });
            let data = {
              id: this.detailData.serviceRunid + "-1", //事项id
              receiveUser: this.detailData.applyUserid, //接收者userId
              memo:
                "您在" +
                moment(this.detailData.applyTime).format(
                  "YYYY年MM月DD日HH点mm分"
                ) +
                "申请的【" +
                this.matterData[0].processInstance.name +
                "】，已被" +
                this.matterData[0].assigneeUser.nickname +
                "终止，请点击查看详情！", //消息内容
              sendUser: this.matterData[0].assigneeUser.id, //发送者userId
              serviceId: this.detailData.serviceId, //服务id
              f4: this.matterData[0].processInstance.name
            };
            console.log(data);
            sendMsg(data).then(res => {
              console.log(res);
              if (res.msgCode == 0) {
                this.goBack();
              }
            });
            this.goBack();
          } else {
            this.$message({
              message: res.msg,
              type: "error"
            });
          }
        })
        .catch(e => {
          this.loading = false;
          this.$message({
            message: e.msg,
            type: "error"
          });
        });
    },
    //驳回
    rollback() {
      this.loading = true;
      this.loadingText = "正在驳回中，请稍后！";
      let params = {
        id: this.matterData[0].id,
        reason: this.textarea
      };
      rollbackMatter(params)
        .then(res => {
          this.loading = false;
          console.log(res);
          if (res.data) {
            this.$message({
              message: "审批驳回！",
              type: "success"
            });
            let data = {
              id: this.detailData.serviceRunid + "-1", //事项id
              receiveUser: this.matterData[1].assigneeUser.id, //接收者userId
              memo:
                "您在" +
                moment(this.matterData[1].createTime).format(
                  "YYYY年MM月DD日HH点mm分"
                ) +
                "办理了【" +
                this.matterData[0].processInstance.name +
                "】，已被" +
                this.matterData[0].assigneeUser.nickname +
                "驳回，请点击查看详情！", //消息内容
              sendUser: this.matterData[0].assigneeUser.id, //发送者userId
              serviceId: this.detailData.serviceId, //服务id
              f4: this.matterData[0].processInstance.name
            };
            console.log(data);
            sendMsg(data).then(res => {
              console.log(res);
              if (res.msgCode == 0) {
                this.goBack();
              }
            });
            // this.goBack();
          } else {
            this.$message({
              message: res.msg,
              type: "error"
            });
          }
        })
        .catch(e => {
          this.loading = false;
          this.$message({
            message: e.msg,
            type: "error"
          });
        });
    },
    //转办
    update() {
      let params = {
        id: this.matterData[0].id,
        assigneeUserId: this.textarea
      };
      updateMatter(params)
        .then(res => {
          console.log(res);
        })
        .catch(e => {
          console.log(e);
        });
    },
    async getRunById() {
      const data = await queryRunById(this.runid);
      this.detailData = data.data;
      console.log("1111111111111", this.detailData);
      if (this.detailData.f1 === "门禁授权申请") {
        this.detailUrl =
          "../accessAuthorizationDetailIframe?id=" + this.detailid;
      } else if (this.detailData.f1 === "校史馆参观预约") {
        this.detailUrl = "../SMRDetaileIframe?id=" + this.detailid;
      } else if (this.detailData.f1 === "《普通高等学校录取新生名册》查询复印服务") {
        this.detailUrl = "../admissionRosterCopyDetaileIframe?id=" + this.detailid;
      }else if (this.detailData.f1 === "档案查询预约"){
        this.detailUrl = "../archiveQueryDetails?id=" + this.detailid;
      }
    },
    // 返回个人中心
    goBack() {
      this.$router.push("/userCenter");
    }
  }
};
</script>
<style>
.rightbox {
  border-bottom: 2px solid #ececec;
  text-align: center;
  font-size: 24px;
  padding: 5px 0px;
  background-color: #e2f3cf;
}

.el-step__head.is-finish {
  color: #008a2c;
}

.el-step__head.is-process {
  color: red;
}
</style>